export default __webpack_public_path__ + "static/media/logo-geoamaggi.036a9992.svg";